import { render, staticRenderFns } from "./Beitragsentwicklung.vue?vue&type=template&id=33e4c9bc&"
import script from "./Beitragsentwicklung.vue?vue&type=script&lang=js&"
export * from "./Beitragsentwicklung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports